import { useEffect } from 'react'
import { IntercomProvider as OriginalIntercomProvider, useIntercom } from 'react-use-intercom'
import { config } from '~/shared/configurations'
import { useAppStore } from '~/stores'
import { useFeature } from '~/hooks'

export const INTERCOM_ELEMENT_ID = 'btn-toggle-livechat'
const INTERCOM_APP_ID = config.intercomAppId

const IntercomBootWrapper = ({ children }: React.PropsWithChildren) => {
  const { boot, shutdown } = useIntercom()
  const user = useAppStore((s) => s.currentUser)
  const activeWorkspace = useAppStore((s) => s.activeWorkspace)

  useEffect(() => {
    if (!user || !activeWorkspace) return
    boot({
      userId: user.id,
      email: user.email,
      customAttributes: { workspaceId: activeWorkspace.id },
      alignment: 'right',
      verticalPadding: 50,
      hideDefaultLauncher: true,
      customLauncherSelector: `#${INTERCOM_ELEMENT_ID}`,
    })
  }, [user, activeWorkspace, boot, shutdown])

  return <>{children}</>
}

export const IntercomProvider = ({ children }: React.PropsWithChildren) => {
  const useWebchatHelpdesk = useFeature('webchat-instead-of-intercom')
  if (useWebchatHelpdesk) {
    return <>{children}</>
  }

  return (
    <OriginalIntercomProvider shouldInitialize={!useWebchatHelpdesk} appId={INTERCOM_APP_ID ?? ''} autoBoot={false}>
      <IntercomBootWrapper>{children}</IntercomBootWrapper>
    </OriginalIntercomProvider>
  )
}
